import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  unit: {
    backgroundColor: palette.shades[100],
    padding: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& + &': {
      borderTop: "1px solid ".concat(palette.shades[300])
    },
    '& > div:first-child': {
      paddingRight: '16px'
    },
    '& > div:last-child': {
      flexShrink: 0
    }
  },
  smallField: {
    width: '140px',
    '& + &': {
      marginLeft: '10px'
    }
  },
  copyButton: {
    minWidth: '0',
    padding: '12px',
    marginLeft: '-2px',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    '& path': {
      fill: palette.shades[100]
    },
    '&.hidden': {
      opacity: 0,
      pointerEvents: 'none'
    }
  },
  datePicker: {
    marginLeft: '8px',
    '& > div': {
      maxWidth: '140px'
    }
  }
}));
export default useStyles;